(() => {
  const form = document.getElementById('back-in-stock-form');
  if (!form) return;

  const wrapper = document.querySelector('.bis-content');
  const emailInput = document.getElementById('back-in-stock-email');
  const submitButton = form.querySelector('button');
  const apiKey = form.dataset.kListId;

  function getVariantId() {
    return document.querySelector(
      'form[action*="/cart/add"] input[name="id"]'
    )?.value;
  }

  const variantId = getVariantId();

  const SUCCESS_KEY = `bis_success_${variantId}`;
  const EMAIL_KEY = `bis_email_${variantId}`;

  const setState = (state) => {
    wrapper.classList.remove('is-success', 'is-error');
    if (state) wrapper.classList.add(state);
  };
  
  if (variantId) {
    const savedEmail = sessionStorage.getItem(EMAIL_KEY);

    if (sessionStorage.getItem(SUCCESS_KEY)) {
      setState('is-success');
    }

    if (savedEmail) {
      const emailPlaceholder = wrapper.querySelector('.bis_sub_email');
      if (emailPlaceholder) {
        emailPlaceholder.textContent = savedEmail;
      }
    }
  }

  async function subscribe(email, variantId) {
    const response = await fetch(
      `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${apiKey}`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/vnd.api+json',
          revision: '2024-10-15'
        },
        body: JSON.stringify({
          data: {
            type: 'back-in-stock-subscription',
            attributes: {
              channels: ['EMAIL'],
              profile: {
                data: {
                  type: 'profile',
                  attributes: { email }
                }
              }
            },
            relationships: {
              variant: {
                data: {
                  type: 'catalog-variant',
                  id: `$shopify:::$default:::${variantId}`
                }
              }
            }
          }
        })
      }
    );

    if (!response.ok) {
      throw new Error(await response.text());
    }
  }

  form.addEventListener('submit', async (e) => {
    e.preventDefault();

    const variantId = getVariantId();
    if (!variantId) return setState('is-error');

    const email = emailInput.value.trim();

    try {
      submitButton.disabled = true;

      await subscribe(email, variantId);

      sessionStorage.setItem(`bis_success_${variantId}`, '1');
      sessionStorage.setItem(`bis_email_${variantId}`, email);

      setState('is-success');

      const emailPlaceholder = wrapper.querySelector('.bis_sub_email');
      if (emailPlaceholder) {
        emailPlaceholder.textContent = email;
      }

      form.reset();
    } catch (error) {
      console.error(error);
      setState('is-error');
    } finally {
      submitButton.disabled = false;
    }
  });
})();